let activeDialogCount = 0;
type DialogListener = (isOpen: boolean) => void;
const listeners = new Set<DialogListener>();

const notify = () => {
  const open = activeDialogCount > 0;
  listeners.forEach((fn) => {
    try {
      fn(open);
    } catch {
      // ignore
    }
  });
};

export const subscribeDialogState = (fn: DialogListener): (() => void) => {
  listeners.add(fn);
  fn(activeDialogCount > 0);
  return () => {
    listeners.delete(fn);
  };
};

export const incrementActiveDialogs = (): void => {
  activeDialogCount++;
  notify();
};

export const decrementActiveDialogs = (): void => {
  activeDialogCount = Math.max(0, activeDialogCount - 1);
  notify();
};

export const isAnyDialogOpen = (): boolean => activeDialogCount > 0;

